import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CustomerModel } from '@df/session/api/customer.model';
@Component({
    selector: 'account-greeting',
    templateUrl: './account-greeting.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class AccountGreetingComponent {
    constructor(private customerModel: CustomerModel) { }
    get customerName(): string {
        return this.customerModel.data.firstname;
    }
}
